/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EmailExcludeOutlineIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Email Exclude Outline',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M34.875 2H1.125A1.147 1.147 0 0 0 0 3.167v25.666A1.147 1.147 0 0 0 1.125 30h14.784a11.411 11.411 0 0 1-.359-2H2v-2.392l11.165-8.358 3.635 2.725a1.967 1.967 0 0 0 .852.344 11.485 11.485 0 0 1 7.222-4.619L34 8.835v9.055a11.561 11.561 0 0 1 2 1.963V3.167A1.147 1.147 0 0 0 34.875 2ZM2 23.107V8.881L11.5 16Zm16-4.732L2 6.38V4h32v2.334Z"
    />
    <path
      d="M27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9ZM27 34a6.966 6.966 0 0 1-5.525-11.252l9.777 9.777A6.935 6.935 0 0 1 27 34Zm5.525-2.748-9.777-9.777a6.966 6.966 0 0 1 9.777 9.777Z"
    />
  </svg>`;
};
